var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDixel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 100,
    viewBox: "0 0 100 100",
    width: 100,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    fill: "#111229",
    r: 50
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.07 20.208c4.073 0 7.801.693 11.186 2.08 3.385 1.386 6.294 3.343 8.727 5.871s4.31 5.545 5.633 9.052c1.322 3.507 1.983 7.353 1.983 11.539 0 4.24-.66 8.1-1.983 11.58-1.322 3.48-3.2 6.483-5.633 9.01-2.433 2.529-5.328 4.486-8.687 5.872-3.358 1.387-7.1 2.08-11.226 2.08h-23.403v-45.066h11.983v-12.018zm39.513 45.066v12.018h-11.983v-12.018h11.984zm-38.542-33.048h-12.391v33.048h12.39c2.184 0 4.165-.401 5.943-1.204a13.404 13.404 0 0 0 4.599-3.399c1.288-1.464 2.282-3.203 2.982-5.217s1.05-4.249 1.05-6.704c0-2.424-.35-4.65-1.05-6.68s-1.694-3.777-2.982-5.241a13.351 13.351 0 0 0 -4.62-3.4c-1.536-.687-3.206-1.08-5.01-1.179l-.912-.024z",
    fill: "#c6f120",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDixel);
export default __webpack_public_path__ + "static/media/dixel.51dbd0b9c83e5def0699d1c447dde060.svg";
export { ForwardRef as ReactComponent };